module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABFElEQVQ4T6XTsUrDQBgH8P+XKljIULCgg24d2mdohwqOLl5w8BFaH8KHEJOxT1AKDrbQwdHFB6jgpmDBQXDoBdL0Kzm49HKJQ5Os/+//4/IdR8KXcxC31+xcPg2P3mF8wpevBDQj0JWd6THyAvkJ4AzMywhO3xwUweqHQM2ibAc8/LVRO3wB4dQevH5c9RyHpgDc/xBKJK8CooAqSAqURTJAGSQH5BDgazyon+tfzS4WH4WACKIu8XoGggtgMR7UOxqwsrccYJflJr54vnOXCVCUZYB9ywmcAmXKyakUULasgCplBXi+/FbvAFiYC+vf88HxSfirb8LMzBdLIpAjMFohxzd62+mV+eGEiBtyE9/amZ7ZAp0aH3WAaoH3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/study/statistics/icon1.png
// module id = 3Jrp
// module chunks = 96